export const SALE_FLOW_STAGE = {
  signature: "signature",
  networkSwitch: "network_switch",
  approval: "approval",
  approvalReceipt: "approval_receipt",
  purchase: "purchase",
  purchaseReceipt: "purchase_receipt",
} as const;

export const SALE_CHAIN_DECIMALS = {
  bscMainnet: 18,
  defaultStablecoin: 6,
} as const;

export const SALE_SUPPORTED_CHAIN_ERROR =
  "Please switch to one of the supported sale networks before buying.";

export const SALE_PENDING_ERROR =
  "A wallet action is already in progress. Please finish it in your wallet.";

export const BSC_CHAIN_ID = 56;
